import * as React from "react";
import PropTypes from "prop-types";
import { lazy, Suspense } from "react";
import { Spinner } from "@fluentui/react-components";

export const cache = {};

export function LazyIcon(props) {
  const { name, source, ...iconProps } = props;
  const key = source + ":" + name;
  const Icon =
    cache[key] ??
    (source === "atlas"
      ? lazy(() =>
          import("@vectoricons/atlas-icons-react").then((module) => {
            return { default: module[name] };
          })
        )
      : source === "phosphor"
        ? lazy(() =>
            import("@phosphor-icons/react").then((module) => {
              return { default: module[name] };
            })
          )
        : lazy(() =>
            import("lucide-react").then((module) => {
              return { default: module[name] };
            })
          ));
  cache[key] = Icon;

  return (
    <Suspense fallback={<Spinner size="tiny" />}>
      <Icon {...iconProps} className={key} />
    </Suspense>
  );
}

LazyIcon.propTypes = {
  name: PropTypes.string,
  source: PropTypes.string,
};
